export default __webpack_public_path__ + "static/IBM_logo-4bbd1a90f62b3252e3a8ba87fe8d9e03.svg";